module.exports = __webpack_public_path__ + "static/scale-model-of-national-aviary-in-pittsburgh-pennsylvania-38e0a9bd959a2e9da81b6f0abc4c6cde.png";